import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { EstablishmentTechnicalProfessionalValidationSchema } from '@/features/maintenance/establishmentTechnicalProfessionals/schemas/create.schema'
import { useMutation } from '@tanstack/react-query'

interface UseCreateEstablishmentTechnicalProfessionalProps {
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

export const useCreateEstablishmentTechnicalProfessional = ({
  onSuccess,
  onError,
}: UseCreateEstablishmentTechnicalProfessionalProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createEstablishmentTechnicalProfessional'],
    mutationFn: async (form: EstablishmentTechnicalProfessionalValidationSchema) => {
      const establishment_technical_professional = {
        ...form,
      }

      return privateAxios.post(
        '/maintenance/establishment_technical_professionals',
        establishment_technical_professional,
      )
    },
    onSuccess,
    onError,
  })
}
